import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const createAddonsReducer = ({
    AP_INTEGRATION_ACCESS_ENABLED = true
}) => {
    const initialState = {
        isShown: false,
        apIntegrationAccessEnabled: AP_INTEGRATION_ACCESS_ENABLED,
    }

    return handleActions({
        [ActionTypes.ADDONS_MENU_TOGGLE]: (state) => ({
            ...state,
            isShown: !state.isShown,
        }),
        [ActionTypes.ADDONS_MENU_CLOSE]: (state) => ({
            ...state,
            isShown: false,
        }),
    }, initialState)
}

export default createAddonsReducer



// WEBPACK FOOTER //
// ./web/js/support/addons/reducer.js